import {ApexOptions} from "apexcharts";

export const CustomOptionsConfig: ApexOptions = {
    xaxis: {
        labels: {
            show: true,
            style: {
                cssClass: 'text-[11px] font-normal fill-header'
            }
        },
        axisBorder: {
            show: true,
        },
        axisTicks: {
            show: true,
        },
    },
    yaxis: {
        show: true,
        labels: {
            show: true,
            style: {
                cssClass: 'text-[11px] fill-header'
            },
            formatter: function (value) {
                return '$' + (value ? value : '-');
            }
        }
    },
    chart: {
        sparkline: {
            enabled: false
        },
        height: "100%",
        width: "100%",
        type: "area",
        dropShadow: {
            enabled: true,
        },
        toolbar: {
            show: true,
        },
    },
    tooltip: {
        enabled: true,
        x: {
            show: true,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        width: 2
    },
    legend: {
        show: true
    },
    grid: {
        show: false,
    },
}
